const toggleTab = (e) => {
	e.preventDefault();
	let target = null;

	// If tab is not already active
	if (!e.target.classList.contains('active')) {
		// get new tab to target
		target = e.target.dataset.tab;
		const controls = e.target.parentNode;
		const block = controls.parentNode;

		// loop thru all controls and remove active state
		for (let control of controls.children) {
			control.classList.remove('active');
		}
		// set new active control
		e.target.classList.add('active');

		// loop thru all content containers and set target tab to active
		const contents = block.querySelectorAll('.block-tab-form__content');
		for (let content of contents) {
			if (content.dataset.tab !== target) {
				content.classList.remove('active');
			} else {
				content.classList.add('active');
			}
		}
	}
};

const initTabs = () => {
	const controls = document.querySelectorAll(
		'.block-tab-form__control'
	);
	
	if (controls.length) {
		controls.forEach((control) => {
			control.addEventListener('click', toggleTab);
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initTabs();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
